import { Typography } from '@mui/material';
import { styled } from '@mui/system'

export const DivContainer = styled('div')((props) => ({
    background: "#849C6A",
    width: '100%',
    padding: 5,
}))

export const PromotionTypography = styled(Typography)((props) => ({
    color: 'white',
    textAlign: 'center',
    [props.theme.breakpoints.down('sm')]: {
        fontSize: 25,
        padding: 10
    },
}))

export const Promotion = () => {
    return (
        <DivContainer>
            <PromotionTypography variant="h5">Spring Sale: Day Care <span style={{ fontWeight: 600 }}>400</span> &amp; Day Boarding <span style={{ fontWeight: 600 }}>₹700</span>. Call Us Now</PromotionTypography>
        </DivContainer>
    )
}